window.RSVWishlist = {
  KEY: 'rsv_wishlist',

  get() {
    try { return JSON.parse(localStorage.getItem(this.KEY) || '[]'); } 
    catch(e) { return []; }
  },

  save(list) {
    localStorage.setItem(this.KEY, JSON.stringify(list));
  },

  has(id) {
    return this.get().includes(String(id));
  },

  add(id) {
    const list = this.get();
    id = String(id);
    if (!list.includes(id)) {
      list.push(id);
      this.save(list);
    }
    this.update();
  },

  remove(id) {
    id = String(id);
    const list = this.get().filter(i => i !== id);
    this.save(list);
    this.update();
  },

  update() {
    const list = this.get();
    const count = list.length;
    document.querySelectorAll('[data-wishlist-id]').forEach(btn => {
      const id = String(btn.getAttribute('data-wishlist-id'));
      const active = list.includes(id);
      btn.classList.toggle('wishlisted', active);
      const svg = btn.querySelector('svg');
      if(svg) {
        svg.style.fill = active ? '#111' : 'none';
        svg.style.stroke = '#111';
      }
    });
    document.querySelectorAll('.wishlist-badge-count').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
    const headerWish = document.getElementById('rsv-header-wish');
    if(headerWish) {
      const svg = headerWish.querySelector('svg');
      if(svg) {
        svg.style.fill = count > 0 ? '#111' : 'none';
        svg.style.stroke = '#111';
      }
    }
    document.dispatchEvent(new Event('wishlist-updated'));
  },

  init() {
    document.addEventListener('click', e => {
      const btn = e.target.closest('[data-wishlist-id]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      const id = String(btn.getAttribute('data-wishlist-id'));
      if(this.has(id)) {
        this.remove(id);
      } else {
        this.add(id);
      }
      btn.classList.add('wish-pop');
      setTimeout(() => btn.classList.remove('wish-pop'), 300);
    });
    this.update();
  }
};

document.addEventListener('DOMContentLoaded', () => window.RSVWishlist.init());

function qaCloseDrawer() {
  const drawer = document.getElementById('qa-drawer');
  const overlay = document.getElementById('qa-overlay');
  if(drawer) drawer.style.display = 'none';
  if(overlay) overlay.style.display = 'none';
  document.body.classList.remove('qa-open');
}

function qaOpenDrawer(pid) {
  const drawer = document.getElementById('qa-drawer');
  const overlay = document.getElementById('qa-overlay');
  const sizesContainer = document.getElementById('qa-drawer-sizes');
  const msg = document.getElementById('qa-drawer-msg');
  if(!drawer || !sizesContainer) return;

  const originalPanel = document.getElementById('qa-' + pid);
  if(!originalPanel) return;

  sizesContainer.innerHTML = '';
  msg.textContent = '';
  msg.style.cssText = '';

  const variants = originalPanel.querySelectorAll('.qa-size');
  variants.forEach(btn => {
    const b = document.createElement('button');
    b.textContent = btn.textContent;
    b.disabled = btn.disabled;
    b.style.cssText = 'font-family:Outfit,sans-serif;font-size:12px;letter-spacing:0.06em;border:0.5px solid ' + (btn.disabled ? '#eee' : '#ddd') + ';padding:10px 16px;background:#fff;color:' + (btn.disabled ? '#ccc' : '#111') + ';cursor:' + (btn.disabled ? 'not-allowed' : 'pointer') + ';' + (btn.disabled ? 'text-decoration:line-through;' : '');
    if(!btn.disabled) {
      const variantId = btn.getAttribute('data-variant');
      b.addEventListener('click', function() {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {'Content-Type':'application/json'},
          body: JSON.stringify({id: variantId, quantity: 1})
        })
        .then(r => r.json())
        .then(() => {
  msg.style.cssText = 'color:#111;font-size:11px;font-weight:500;letter-spacing:0.1em;text-transform:uppercase;padding:8px 0;display:block;';
  msg.textContent = '✓ Añadido a tu carrito';
  fetch('/cart.js').then(r=>r.json()).then(cart=>{
    if (typeof updateBadge === 'function') updateBadge(cart.item_count);
    if (typeof renderCart === 'function') renderCart(cart);
  });
  setTimeout(() => {
    qaCloseDrawer();
    if (typeof openCart === 'function') openCart();
  }, 800);
})
        .catch(() => { msg.textContent = 'Error, intenta de nuevo'; });
      });
    }
    sizesContainer.appendChild(b);
  });

  drawer.style.display = 'block';
  if(overlay) overlay.style.display = 'block';
  document.body.classList.add('qa-open');
}

document.addEventListener('click', function(e) {
  const trigger = e.target.closest('.qa-trigger');
  if(trigger) {
    e.preventDefault();
    e.stopPropagation();
    const wrap = trigger.closest('.qa-wrap');
    const pid = wrap.getAttribute('data-product-id');
    const drawer = document.getElementById('qa-drawer');
    if(drawer && drawer.style.display === 'block' && drawer.dataset.pid === pid) {
      qaCloseDrawer();
    } else {
      if(drawer) drawer.dataset.pid = pid;
      qaOpenDrawer(pid);
    }
    return;
  }

  const closeBtn = e.target.closest('.qa-close');
  if(closeBtn) {
    e.preventDefault();
    e.stopPropagation();
    qaCloseDrawer();
    return;
  }
});